import { PracticeIdentifierValues } from 'util/practiceIdentifiers'

import axiosClient from './base'

const VERIFY_PRACTICE_EXIST = '/api/practice/validate'

// TODO: practiceId shouldn't be null but it needs refactoing
export const updatePractice = async (
	practiceId: string | undefined,
	data: IPractice
): Promise<IPractice> => {
	const response = await axiosClient.put(`/api/practices/${practiceId}`, data)
	return response?.data?.practice
}

export const removePractice = (practiceId) => axiosClient.delete(`/api/practices/${practiceId}`)

export const getPractice = (practiceId) => axiosClient.get(`/api/practices/${practiceId}`)

export const listPracticeClients = ({ practiceId, name, pageNumber, pageSize, ...props }) =>
	axiosClient.get(`/api/practices/${practiceId}/clients`, {
		params: {
			name,
			pageNumber,
			pageSize,
			...props
		}
	})

export const getCommunicationHistory = ({
	practiceId,
	pageNumber,
	pageSize,
	endDate,
	startDate,
	search
}) =>
	axiosClient.get(`/api/practices/${practiceId}/communication-history`, {
		params: {
			pageNumber,
			pageSize,
			startDate,
			endDate,
			search
		}
	})

export const getPriorityCallList = ({
	practiceId,
	pageNumber,
	pageSize,
	reminderDueStartDate,
	reminderDueEndDate,
	reminderDescriptions
}) =>
	axiosClient.get(`/api/practices/${practiceId}/priority-call-list`, {
		params: {
			pageNumber,
			pageSize,
			reminderDueStartDate,
			reminderDueEndDate,
			reminderDescriptions
		}
	})

export const inviteUserToPractice = (params: InvitePracticeUser) =>
	axiosClient.post(`/api/practices/${params.practiceId}/invite-user`, params)

export const createStripeAccountSession = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/stripe_account_sessions`)

export const activatePracticeRequest = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/activate`)

export const createStripeVerificationSession = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/verification-sessions`)

export const verifyPracticeExists = ({ practiceWebsite, addressLine, zipCode, practiceName }) =>
	axiosClient.post(VERIFY_PRACTICE_EXIST, {
		practiceWebsite,
		addressLine,
		zipCode,
		practiceName
	})

export const createTerminalOrderIntent = (
	practiceId: string,
	payload: ICreateTerminalOrderIntentParams
) => axiosClient.post(`/api/practices/${practiceId}/terminal-order-intent`, payload)

/**
 * Provisions an additional product on a practice that already exists, used by the
 * signup-v2 product picker when a signed-in user adds Payments or Patient Financing.
 *
 * @param practiceId - Practice id from the context payload (a Stripe `acct_*` id for
 * payments-enabled practices, otherwise the practice document id).
 * @param product - Product to enable: `payments` (Stripe Connect) or `lending` (financing).
 * @param body - Identifiers the practice is missing and the caller collected — any of
 * `phone`, `address`, `zip`, `industry`, plus the `city` and `state` that come with a
 * re-picked address. Rejected with code E3029 when one the backend needs is absent here
 * and on the practice.
 * @returns Axios response whose `data.message` confirms the product was added.
 */
export const addProductToPractice = (
	practiceId: string,
	product: 'payments' | 'lending',
	body: PracticeIdentifierValues = {}
) => axiosClient.post(`/api/practices/${practiceId}/products/${product}`, body)

export const sendSurchargeOptInRequest = (practiceId: string) => {
	axiosClient.post(`/api/practices/${practiceId}/surcharge/opt-in`)
}
